import React from 'react';
import { seriesHint } from './seriesScope';

// The World Builder's book filter can add the book's series entries (#1138). Wording
// approved by the owner.
const IncludeSeriesSwitch: React.FC<{
  checked: boolean;
  onChange: (on: boolean) => void;
  seriesTitles: string[];
}> = ({ checked, onChange, seriesTitles }) => {
  const id = React.useId();
  const hint = seriesHint(seriesTitles);
  // The hover text is also the accessible description, so it reaches keyboard and screen reader users.
  return (
    <label className="rf-filter-toggle" title={hint}>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-describedby={id} />
      <span>Include entries from the series</span>
      <span id={id} hidden>{hint}</span>
    </label>
  );
};

export default IncludeSeriesSwitch;
